/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TTLOStateResponse
 */
export interface TTLOStateResponse {
    /**
     * 
     * @type {string}
     * @memberof TTLOStateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TTLOStateResponse
     */
    errorMessage?: string | null;
}

export function TTLOStateResponseFromJSON(json: any): TTLOStateResponse {
    return TTLOStateResponseFromJSONTyped(json, false);
}

export function TTLOStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function TTLOStateResponseToJSON(value?: TTLOStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


